<template>
  <div id="home">
    <div class="content_box">
      <div class="inner">
        <div class="link_parent_box">
          <slot name="alerts"></slot>
          <!-- <div class="link_box" v-if="showLink || idPass">
            <ul>
              <li class="active">
                <a @click="getDepositBlacklist()" data-testid="depositFunds">
                  <div class="top">
                    <img src="@/assets/images/home/icons-big-meta-trader@3x.png" alt />
                  </div>
                  <div class="bottom">
                    {{ $t('common.button.depositFunds') }}
                  </div>
                </a>
              </li>
              <li>
                <a @click="getWithdrawalBlacklist()" data-testid="withdrawFunds">
                  <div class="top">
                    <img src="@/assets/images/home/icons-big-funding@3x.png" alt />
                  </div>
                  <div class="bottom">
                    {{ $t('common.button.withdrawFunds') }}
                  </div>
                </a>
              </li>
              <li v-if="openAdditionAccountEnabled">
                <a @click="$router.push('openLiveAccount')" data-testid="openLiveAccount">
                  <div class="top">
                    <img src="@/assets/images/home/icons-big-client-portal@3x.png" alt />
                  </div>
                  <div class="bottom">
                    {{ $t('menu.openAdditAcc') }}
                  </div>
                </a>
              </li>
              <li>
                <a v-if="checkIfIBUser()" @click.stop.prevent="$redirect.redirectToIbPortal" data-testid="ibPortal">
                  <div class="top">
                    <img src="@/assets/images/home/icons-big-downloads@3x.png" alt />
                  </div>
                  <div class="bottom">
                    {{ $t('common.button.ibPortal') }}
                  </div>
                </a>
                <a v-else @click.stop.prevent="$router.push('downloads')" data-testid="downloads">
                  <div class="top">
                    <img src="@/assets/images/home/icons-big-downloads@3x.png" alt />
                  </div>
                  <div class="bottom">
                    {{ $t('common.button.download') }}
                  </div>
                </a>
              </li>
            </ul>
          </div> -->
        </div>
        <slot></slot>
      </div>
    </div>
    <slot name="components"></slot>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import blackList from '@/mixins/blackList';

export default {
  name: 'HomeTemplate',
  mixins: [blackList],
  props: {
    showLink: { type: Boolean, default: true }
  },
  computed: {
    openAdditionAccountEnabled() {
      return (
        this.openAccountEnabled &&
        this.idPass &&
        !this.$config.restrictOpenAdditionAccountCountries(this.regulator).includes(parseInt(this.countryCode))
      );
    },
    ...mapState('common', ['openAccountEnabled', 'countryCode']),
    ...mapGetters('common', ['idPass', 'poaPass'])
  },
  methods: {
    checkIfIBUser() {
      const userType = this.$store.state.common.userType;
      //ib type: individual 5, company 16
      if (userType === 5 || userType === 16) return true;
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/home.scss';
</style>
